import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import WikiLink from './WikiLink';
import { useAuth } from '../../auth/useAuth';

export default function MarkdownView({ content, lang }) {
    const { lang: userLang } = useAuth();
    const activeLang = lang || userLang || 'en';

    if (!content) {
        return (
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.85rem', fontStyle: 'italic' }}>
                No content available in this language.
            </div>
        );
    }

    // Process [[slug]] patterns - convert to WikiLink components
    const processedContent = content.replace(
        /\[\[([^\]]+)\]\]/g,
        '[[WIKILINK:$1]]'
    );

    // Split by WikiLink markers
    const parts = processedContent.split(/\[\[WIKILINK:([^\]]+)\]\]/);

    const renderContent = () => {
        if (parts.length === 1) {
            // No wiki links found, render as plain markdown
            return (
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {content}
                </ReactMarkdown>
            );
        }

        // Has wiki links, render mixed content
        const elements = [];
        for (let i = 0; i < parts.length; i++) {
            if (i % 2 === 0) {
                // Regular text/markdown
                if (parts[i]) {
                    elements.push(
                        <span key={`text-${i}`}>
                            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                {parts[i]}
                            </ReactMarkdown>
                        </span>
                    );
                }
            } else {
                // WikiLink slug
                const slug = parts[i].trim();
                elements.push(<WikiLink key={`link-${i}`} slug={slug} />);
            }
        }
        return elements;
    };

    return (
        <div className="markdown-content" style={{
            color: 'var(--text-primary)',
            lineHeight: 1.7,
            fontSize: '0.9rem',
        }}>
            {renderContent()}
        </div>
    );
}